import { useState } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { putRegion } from "../../controllers/org";
import Loading from "../loading/Loading";
import { useAuth } from "../auth/AuthProvider";
import { useToast } from "../toast/ToastContext";

function CrearRegion({ onSuccess }) {
  const [nombreRegion, setNombreRegion] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useAuth();
  const showToast = useToast();

  // const options = [
  //   { id: 'opt1', label: 'Option 1', value: 'value1' },
  //   { id: 'opt2', label: 'Option 2', value: 'value2' },
  //   { id: 'opt3', label: 'Option 3', value: 'value3' },
  // ];

  async function submit(e) {
    e.preventDefault();
    console.log(e);
    setIsLoading(true);
    try {
      await putRegion(nombreRegion, token);
      showToast({
        message: `Se creó la región ${nombreRegion} con éxito.`,
        bg: 'success',
        autohide: true,
        delay: 7000,
        title: 'Región creada'
      });

      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess();
      }
    }
    catch (e) {
      showToast({
        message: 'Error al crear región. Por favor intenta más tarde.',
        bg: 'danger',
        autohide: true,
        delay: 7000,
        title: 'Error al crear región'
      });
    }
    setIsLoading(false);
  }

  if (isLoading) {
    return <Card>
      <Card.Header>Crear Región</Card.Header>
      <Card.Body><Loading text="Creando región..." /></Card.Body>
    </Card>
  }

  return <Card>
    <Card.Header>Crear Región</Card.Header>
    <Card.Body>
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Nombre de la región</Form.Label>
          <Form.Control type="text" placeholder="Región" value={nombreRegion} onChange={e => setNombreRegion(e.target.value)} required />
        </Form.Group>
        <Form.Group className="mb-3 submit-buttons-wrapper">
          <Button key='submit-btn-new-region' type='submit' variant='primary' onClick={submit}>Guardar región</Button>
        </Form.Group>
      </Form>
    </Card.Body>
  </Card>
}

export default CrearRegion;
